import React, { useState } from "react";
import { usePutStreamMutation } from "../../api/apiSlice";
import { camList } from "../../app/streamData";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { IStream } from "api/apiTypes";

interface AddStreamFormProps {
  activeStreams: IStream[];
}

export const AddStreamForm = (props: AddStreamFormProps) => {
  var activeStreams = props.activeStreams;
  const CUSTOM_STREAM = "custom";
  const [putNewStream, { isLoading }] = usePutStreamMutation();
  const [selectedStreamName, setSelectedStreamName] = useState("");
  const onStreamIdChanged = (ev: React.ChangeEvent<HTMLSelectElement>) => setSelectedStreamName(ev.currentTarget.value);
  const [customStreamName, setCustomStreamName] = useState("");
  const [customStreamId, setCustomStreamId] = useState("");
  const onCustomStreamNameChanged = (ev: React.ChangeEvent<any>) => setCustomStreamName(ev.currentTarget.value);
  const onCustomStreamIdChanged = (ev: React.ChangeEvent<any>) => setCustomStreamId(ev.currentTarget.value);

  const onAddStreamClicked = async () => {
    var newStream = camList.find(function (el) {
      return el.youtubeId === selectedStreamName;
    });
    var name = selectedStreamName === CUSTOM_STREAM ? customStreamName : newStream?.name;
    var youtubeId = selectedStreamName === CUSTOM_STREAM ? customStreamId : newStream?.youtubeId;
    try {
      var stream = { name: name, videoId: youtubeId };
      await putNewStream(stream).unwrap();
      setCustomStreamId("");
      setCustomStreamName("");
    } catch (err) {
      console.error("Adding new stream failed: for name " +name+ " and video Id " + youtubeId, err);
    }
  };

  // Create an array of all streams in camList that aren't in activeStreams
  var inactiveStreams = camList.filter(function (el) {
    return (
      activeStreams.findIndex(function (f) {
        return f.videoId === el.youtubeId;
      }) < 0
    );
  });

  // Create an array of options for the select box
  var options = inactiveStreams.map(function (el) {
    return (
      <option key={el.youtubeId} value={el.youtubeId}>
        {el.name}
      </option>
    );
  });
  //Add custom option to list of options
  options.push(
    <option key={CUSTOM_STREAM} value={CUSTOM_STREAM}>
      Custom
    </option>
  );
  var customStreamNameView =
    selectedStreamName === "custom" ? (
      <Col xs="auto">
        <Form.Control type="input" onChange={(ev) => onCustomStreamNameChanged(ev)} placeholder="Stream Name"></Form.Control>
      </Col>
    ) : null;
  var customStreamUrlView =
    selectedStreamName === "custom" ? (
      <Col xs="auto">
        <Form.Control type="input" onChange={(ev) => onCustomStreamIdChanged(ev)} placeholder="Stream Video Id"></Form.Control>
      </Col>
    ) : null;

  var isDisabled = selectedStreamName.length < 2 || isLoading;
  if (selectedStreamName === CUSTOM_STREAM) {
    isDisabled =
      customStreamName.length < 1 ||
      customStreamId.length < 1 ||
      isLoading;
  }

  return (
    <div>
      <h4 className="mb-2">Add a New Stream</h4>
      <Form>
        <Row className="align-items-center">
          <Col xs="auto">
            <Form.Select onChange={(choice) => onStreamIdChanged(choice)}>
              <option>&nbsp;</option>
              {options}
            </Form.Select>
          </Col>
          {customStreamNameView}
          {customStreamUrlView}
          <Col xs="auto">
            <Button
              variant="primary"
              disabled={isDisabled}
              onClick={onAddStreamClicked}
            >
              Add Stream
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
